import { useLocation, Link } from "react-router-dom";
import { AlertCircle } from 'lucide-react';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-dark-bg flex flex-col items-center justify-center text-center px-4 relative overflow-hidden">
      <h1 className="absolute text-[12rem] md:text-[20rem] font-black text-dark-card select-none pointer-events-none z-0 opacity-50">
        404
      </h1>

      <div className="relative z-10 bg-dark-card p-12 rounded-3xl border border-dark-border shadow-2xl max-w-lg w-full">
        <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6 border border-red-500/20">
          <AlertCircle className="text-red-500" size={40} />
        </div>

        <h1 className="text-3xl font-bold text-white mb-2">Page introuvable</h1>
        <p className="text-text-muted font-mono bg-dark-bg py-2 px-4 rounded-lg inline-block mb-6 border border-dark-border">
          {location.pathname}
        </p>

        <p className="text-lg text-text-muted mb-8">
          Cette page n'existe pas ou a été déplacée.
        </p>

        <Link
          to="/"
          className="inline-block w-full py-3 bg-primary text-black font-bold rounded-xl hover:bg-primary-hover transition-colors"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}